import { recoverAlreadyPaidPrimaryOnReturn } from '../components/funnelV3/steps/paymentRecovery';
import { useFunnelV3Store } from '../store/funnelV3Store';
import { hydrateQuizFromProfile } from './hydrateQuizFromProfile';

export type PaidResumeDestination = 'paywall' | 'create_account';

/** Active or trialing primary membership. past_due still needs a real payment retry. */
export function isActivePrimaryMembership(member: {
    hasPrimarySubscription?: boolean;
    primarySubscriptionStatus?: string | null;
} | null | undefined): boolean {
    const status = member?.primarySubscriptionStatus;
    if (status === 'active' || status === 'trialing') return true;
    if (status) return false;
    return member?.hasPrimarySubscription === true;
}

export function markPaymentCompletedLocally(): void {
    useFunnelV3Store.getState().updateField('paymentCompleted', true);
    try {
        localStorage.setItem('mc_payment_completed', '1');
    } catch { /* storage disabled */ }
}

/**
 * A signed-in return visit. Paid members finish account setup instead of
 * seeing the card form again. Everyone else continues on the paywall.
 */
export async function destinationAfterSession(): Promise<PaidResumeDestination> {
    const recovered = await recoverAlreadyPaidPrimaryOnReturn();
    if (recovered) {
        markPaymentCompletedLocally();
        return 'create_account';
    }
    await hydrateQuizFromProfile();
    return 'paywall';
}
